import React, { useEffect, useMemo, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { useWindowSize } from "../../hook/useWindowSize";
import { getPropByLanguage } from "../../utils/Language";
import { ITEM_POSITION_ENUMS } from "../../constants";
import { useApp } from "../../contexts";
import { roundNumber } from "../../services/app";
import { useNavigate } from "react-router-dom";
import VideoJS from "../../components/video";

function Item(props) {
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const { T, user, language, convertToLocalCurrency,formatLocalCurrency,
    getCurrency } = useApp();
  const { lan, itemData, isHome } = props;
  const [videoUrl, setVideoUrl] = useState('');

  const [randomClass, setRandomClass] = useState("");
  const [clickedOnce, setClickedOnce] = useState(false);
  const [price, setPrice] = useState(0);
  const navigate = useNavigate();
  
  const handleParentClick = (id) => {
    navigate(`/character-detail/${id}`);
  };

  useEffect(() => {
    if (itemData.itemType == 10) return "";
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemData?.itemId % 7;
    setRandomClass(`suzu-card-image-${arr[random]}`);
  }, []);

  useEffect(() => {
    if (itemData) {
      setPrice(convertToLocalCurrency(
        itemData.price,
        itemData.ccy,
        getCurrency()
      ))
    }
  }, [itemData])
  const handleLoadVideo = () => {
    if (!videoUrl && itemData?.tag_nft_type == 'motion') {
      setVideoUrl(itemData?.short_video_url)
    }
  }
  return (
    <>
      <div
        className={`w-autu item-boxs suzu-card cursor-pointer`}
        onClick={() => handleParentClick(itemData?.id)}
      >
        <div className="rounded-[13px] flex items-center justify-center relative">
          <div
            className={`aspect-[140/140] w-full relative mb-3 rounded-t-[13px] p-[15px] bg-[#F7F7F7] ${randomClass}
            ${
              itemData?.purchase_source == "shopify"
                ? "p-0 overflow-hidden"
                : "p-[15px]"
            }`}
          >
            <div className="w-full relative h-full"> 
              <img
                src={itemData?.img}
                className={`w-full h-full ${
                  itemData?.purchase_source == "shopify"
                    ? "object-cover"
                    : "object-contain"
                }`}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="suzu-card-body">
          <div className={`w-full h-full px-[14px] pt-[0] pb-[16px]`}>
            <div className="flex items-center justify-between mb-[6px] lg:mb-[5px]">
              <p className="leading-[18px] lg:leading-[22px] text-[14px] lg:text-[18px] text-[#131516] font-[600] truncate">
                {itemData?.name}
              </p>
            </div>
            <div className="flex items-center justify-start mb-[6px] gap-3 lg:mb-[5px]">
              <span className="rounded-[30px] px-[6px] xs:px-[10px] text-[12px]/[18px] lg:px-[19px] py-[2px] flex items-center justify-center tag-inapp lg:text-[13px]/[24px]">
                {T("In app")}
              </span>
              <span className="rounded-[30px] px-[6px] xs:px-[10px] text-[12px]/[18px] lg:px-[19px] py-[2px] flex items-center justify-center tag-inmarket lg:text-[13px]/[24px]">
                {T("In market")}
              </span>
            </div>
            <div className="flex items-end justify-between">
              <div className="flex flex-col gap-[5px]">
                <span className="text-[12px] lg:text-[15px] text-[#616161] whitespace-nowrap">
                  {itemData?.gift_type === 0
                    ? T("(Tradeable)")
                    : T("(Use only)")}
                </span>
              </div>
              {itemData?.gift_type === 0 ? (
                <NumberFormat
                  className="text-[#000] text-[14px] lg:text-[20px]/[20px] font-[600]"
                  value={formatLocalCurrency(roundNumber(price, 2))}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={prefixCcySymbol(true, getCurrency())}
                  suffix={suffixCcySymbol(true, getCurrency())}
                  decimalScale={validateDecimalSeparator(
                    baseCurrencyCode(true, getCurrency())
                  )}
                />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Item;
